import React, { Component } from 'react';
import { toSuccess, withSagas } from 'react-async-client';
import PropTypes from 'prop-types';
import { takeEvery } from 'redux-saga/effects';
import Translate from 'react-translate-component';
import { Alert, Button } from 'antd';
import { length, path } from 'ramda';

import { CREATE_EVENT } from 'constants/actionTypes';

@withSagas([function* (getProps) {
    yield takeEvery([toSuccess(CREATE_EVENT)], () => {
        const props = getProps();

        if (path(['needContacts', 'length'], props.putPersonState.data) > 1) {
            props.putPersonState.dispatch(props.values);
        } else {
            props.putPersonState.reset();
        }
    });
}])
export default class StateNeedEvents extends Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        values: PropTypes.object.isRequired,
        params: PropTypes.object.isRequired,
        putPersonState: PropTypes.object.isRequired,
        openModalEventCreate: PropTypes.func.isRequired,
    };

    openEventCreate = (type, typeName, withDocument = false, documentsList) => {
        const { values, params, user } = this.props;

        this.props.openModalEventCreate({
            project: { id: values.projectId },
            person: { id: values.peopleId, text: params.personName },
            participators: params.participators,
            type,
            typeName,
            withDocument,
            documentsList,
            item: {
                position: params.position,
                details: {
                    eventDate: new Date().toLocaleDateString('ru'),
                    responsible: [{
                        id: user.id,
                        text: user.username,
                    }],
                    people: [{
                        id: values.peopleId,
                        text: params.personName
                    }],
                },
            }
        });
    }

    openDocumentCreate = (type, typeName) => {
        this.openEventCreate(type, typeName, true);
    }

    openDocumentsPick = (type, typeName, documents) => {
        this.openEventCreate(type, typeName, false, documents);
    }

    render() {
        const { data } = this.props.putPersonState;

        return data.needContacts ? (
            <div>
                <Alert
                    message={<Translate content='worksheet.messages.needEvents' />}
                    type='warning'
                />
                <ul className='documents-schedule-list'>
                    { data.needContacts.map(({ workcode, contactName, documents = [] }) => (
                        <li key={workcode}>
                            {contactName}
                            <div>
                                <Button onClick={() => this.openEventCreate(workcode, contactName)}>
                                    <Translate content='worksheet.scheduleDocument' />
                                </Button>
                                <Button onClick={() => this.openDocumentCreate(workcode, contactName)}>
                                    <Translate content='worksheet.createDocument' />
                                </Button>
                                { !!length(documents) && (
                                    <Button onClick={() => this.openDocumentsPick(workcode, contactName, documents)}>
                                        <Translate content='worksheet.pickDocuments' />
                                    </Button>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        ) : null;
    }
}
